import { useMutation } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ManagementAddNewLoanValidateAddOld } from 'services/loans/manager'
import posthog from 'posthog-js'

export default function useSetFinalOld() {
    const navigate = useNavigate()
    const { state } = useLocation()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IIManagementAddOldPayload) => {
            return ManagementAddNewLoanValidateAddOld(payload)
        },
        onSuccess: (response, variables) => {
            posthog.capture('old_loan_registered', {
                fund_id: (state as any)?.payload?.moneyPool,
            })
            toast.success('وام با موفقیت ثبت گردید')
            navigate(`/fund/${state?.payload?.moneyPool}`, {
                state: { poolShipId: state?.payload?.poolShip },
            })
        },
        onError: (error: any) => {
            posthog.capture('old_loan_register_failed', {
                step: 'final',
                status: error?.response?.status,
                fund_id: (state as any)?.payload?.moneyPool,
            })
            toast.error('مشکلی رخ داده!')
        },
    })

    return { isLoading, mutate }
}
